/* eslint @typescript-eslint/strict-boolean-expressions: off */

import styles from "./TeamProfile.module.css";
import Row from "gui/layout/row";
import { Icon } from "gui/icon/icon";
import { useAnalytics } from "gui/analytics/analytics";
import { Member } from "gui/TeamPage/fetchStaticTeamProfileData";
import { Avatar } from "gui/avatar/avatar";
import Link from "next/link";
import {
  arrowBelowCenteredOnTrigger,
  centeredBelow,
  TooltipOld,
} from "components/TooltipOld/TooltipOld";
import Linkify from "react-linkify";
import { StaticTeamProfileData } from "../fetchStaticTeamProfileData";

interface Props {
  team: StaticTeamProfileData;
  people: Member[];
}

export default function TeamDetails(props: Props) {
  const { captureEvent } = useAnalytics();

  return (
    <div className={styles["team-details"]}>
      {props.team.bio && (
        <Row gap="small" layout="start-aligned" className={styles.bio}>
          <Icon icon="book" aria-hidden className={styles.icon} />
          <span>
            <Linkify
              componentDecorator={(href, text) => (
                <a
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                >
                  {text}
                </a>
              )}
            >
              {props.team.bio}
            </Linkify>
          </span>
        </Row>
      )}
      {props.team.twitter_handle && (
        <Row gap="small">
          <Icon icon="twitter" className={styles.icon} aria-hidden />
          <a
            target="_blank"
            aria-label="Twitter"
            href={`https://twitter.com/${props.team.twitter_handle}`}
            className={styles["team-details-item"]}
            onClick={() => {
              captureEvent("Team profile Twitter link clicked");
            }}
          >
            @{props.team.twitter_handle}
          </a>
        </Row>
      )}
      {props.team.telegram_handle && (
        <Row gap="small">
          <Icon icon="telegram" aria-hidden />
          <a
            target="_blank"
            aria-label="Telegram"
            href={`https://t.me/${props.team.telegram_handle}`}
            className={styles["team-details-item"]}
            onClick={() => {
              captureEvent("Team profile Telegram link clicked");
            }}
          >
            @{props.team.telegram_handle}
          </a>
        </Row>
      )}
      {props.team.discord_url && (
        <Row gap="small">
          <Icon icon="discord" aria-hidden />
          <a
            target="_blank"
            aria-label="Discord"
            href={`${props.team.discord_url}`}
            className={styles["team-details-item"]}
            onClick={() => {
              captureEvent("Team profile Discord link clicked");
            }}
          >
            {props.team.discord_url}
          </a>
        </Row>
      )}

      {props.people && props.people.length > 0 && (
        <>
          <Row gap="small" layout="start-aligned" className={styles.membersRow}>
            <Icon icon="people" aria-hidden className={styles.icon} />
            <span>Team members</span>
          </Row>
          <Row gap="small" layout="start-aligned" className={styles.membersRow}>
            <div className={styles.members}>
              {props.people.map((p) => (
                <Link key={p.name} href={`/${p.name}`}>
                  <a>
                    <TooltipOld
                      label={p.name}
                      color="black"
                      position={centeredBelow}
                      trianglePosition={arrowBelowCenteredOnTrigger}
                    >
                      <span>
                        <Avatar
                          src={p.profile_image_url || undefined}
                          size={20}
                        />
                      </span>
                    </TooltipOld>
                  </a>
                </Link>
              ))}
            </div>
          </Row>
        </>
      )}
    </div>
  );
}
